export default __webpack_public_path__ + "static/media/warning2.2b224e73.svg";